import axios from 'axios';

const API_BASE_URL = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/tags/`;
const CATEGORY_API_BASE_URL = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/tags/tag-categories`;

export const fetchTags = async () => {
  try {
    const response = await axios.get(API_BASE_URL);
    return response.data;
  } catch (e: any) {
    console.error('Error fetching tags:', e);
    throw e;
  }
};


export const createTag = async (
  tagData: { label: string; color: string; index: number; categoryId?: string }
) => {
  try {
    const response = await axios.post(API_BASE_URL, tagData);
    return response.data.tag;
  } catch (e: any) {
    console.error('Error creating tag:', e);
    throw e;
  }
};

export const updateTag = async (
  id: string,
  updatedTag: { label: string; color: string; index?: number; categoryId?: string }
) => {
  const response = await axios.put(`${API_BASE_URL}${id}`, updatedTag);
  return response.data;
};


export const deleteTag = async (id: string) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}${id}`);
    return response.data;
  } catch (error: any) {
    console.error("Error deleting tag:", error);
    throw error;
  }
};

export const fetchCategories = async () => {
  try {
    const response = await axios.get(CATEGORY_API_BASE_URL);
    return response.data.categories || response.data;
  } catch (e) {
    console.error("Error fetching filter config", e);
    throw e;
  }
};

export const createCategory = async (
  categoryData: { name: string; isMultiSelect?: boolean }
) => {
  try {
    const response = await axios.post(CATEGORY_API_BASE_URL, categoryData);
    return response.data.category || response.data;
  } catch (e: any) {
    console.error('Error creating category:', e);
    throw e;
  }
};

export const updateCategory = async (
  id: string,
  categoryData: { name?: string; isMultiSelect?: boolean }
) => {
  try {
    const response = await axios.put(`${CATEGORY_API_BASE_URL}/${id}`, categoryData);
    return response.data.category || response.data;
  } catch (e: any) {
    console.error('Error updating category:', e);
    throw e;
  }
};

export const deleteCategory = async (id: string) => {
  try {
    const response = await axios.delete(`${CATEGORY_API_BASE_URL}/${id}`);
    return response.data;
  } catch (error: any) {
    console.error("Error deleting category:", error);
    throw error;
  }
};
